// Real rental account service using API endpoints
import { buildApiUrl } from '../config/environment';

export const getRentalAccount = async (rentalAccountId) => {
  try {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(buildApiUrl(`/tenancy-ledgers/${rentalAccountId}`), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch rental account');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching rental account:', error);
    throw error;
  }
};


export const getTenancyLedgerEntries = async (tenancyLedgerId, options = {}) => {
  try {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const queryParams = new URLSearchParams();
    if (options.page) queryParams.append('page', options.page);
    if (options.limit) queryParams.append('limit', options.limit);
    if (options.entry_type) queryParams.append('entry_type', options.entry_type);
    if (options.start_date) queryParams.append('start_date', options.start_date);
    if (options.end_date) queryParams.append('end_date', options.end_date);

    const url = buildApiUrl(`/tenancy-ledgers/${tenancyLedgerId}/entries${queryParams.toString() ? '?' + queryParams.toString() : ''}`);

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch tenancy ledger entries');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching tenancy ledger entries:', error);
    throw error;
  }
};

export const createCharge = async (tenancyLedgerId, chargeData) => {
  try {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(buildApiUrl(`/tenancy-ledgers/${tenancyLedgerId}/charges`), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(chargeData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to create charge');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating charge:', error);
    throw error;
  }
};

export const createPayment = async (tenancyLedgerId, paymentData) => {
  try {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(buildApiUrl(`/tenancy-ledgers/${tenancyLedgerId}/payments`), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(paymentData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to create payment');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating payment:', error);
    throw error;
  }
};

export const deletePayment = async (paymentId) => {
  try {
    const token = sessionStorage.getItem('token');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(buildApiUrl(`/tenancy-ledgers/payments/${paymentId}`), {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to delete payment');
    }

    return { success: true };
  } catch (error) {
    console.error('Error deleting payment:', error);
    throw error;
  }
};